export const glassPanelClasses =
  "rounded-[28px] border border-[#e9dcc8] bg-[#fffdf9] shadow-[0_18px_50px_rgba(84,62,39,0.09)]";

export const glassPanelStrongClasses =
  "rounded-[34px] border border-[#e7d8c0] bg-[#fffaf3] shadow-[0_24px_70px_rgba(84,62,39,0.13)]";

export const sectionCardClasses = `${glassPanelClasses} p-5 sm:p-8`;

export const sectionCardCompactClasses = `${glassPanelClasses} p-5 sm:p-6`;

export const heroPanelClasses = `${glassPanelStrongClasses} relative overflow-hidden`;

export const pageHeadingClasses =
  "text-3xl sm:text-4xl font-bold tracking-tight text-[#213547]";

export const pageHeadingLargeClasses =
  "text-4xl sm:text-5xl font-bold tracking-tight text-[#213547]";

export const pageLeadClasses =
  "mt-3 text-sm sm:text-base leading-7 text-[#5c5b57]";

export const centeredPageHeaderClasses = "mx-auto max-w-2xl text-center";

export const authPageShellClasses =
  "min-h-screen flex items-center justify-center space-y-0";

export const authCardClasses = `${glassPanelClasses} p-5 sm:p-8`;

export const infoCardClasses = `${glassPanelClasses} p-6 sm:p-8`;

export const sectionTitleClasses =
  "text-xl sm:text-2xl font-bold tracking-tight text-[#213547]";

export const mutedDividerClasses = "border-t border-slate-200/70";

export const subtleEyebrowClasses =
  "inline-flex items-center rounded-full border border-[#dfc9aa] bg-[#f9eddc] px-3 py-1 text-xs font-semibold uppercase tracking-[0.24em] text-[#a2572b]";
